import React from 'react';
import {isEmpty} from 'lodash'
import {Grid} from "@material-ui/core"
import {useSelector} from 'react-redux'
import { injectIntl } from 'react-intl';
function DaShBoardHeader(props) {
    const authUser = useSelector(state => state.auth.authUser)
    const currentAccount = useSelector(state => state.accountsData.currentAccount)
    const Bokacurrentuser = useSelector(state => state.DashBoard.Bokacurrentuser)
    const AllKontorLabel = props.intl.formatMessage({ id: 'All.In.Office' });
    const [userName,setUserName] = React.useState("")
    React.useEffect(()=>{
        const userName = isEmpty(Bokacurrentuser)?"":
        (parseInt(Bokacurrentuser) === -1)?
        `${currentAccount.name}`:
        parseInt(Bokacurrentuser) === -2?
        AllKontorLabel:
        `${Bokacurrentuser.FirstName} ${Bokacurrentuser.LastName} `
        setUserName(userName)

    },[Bokacurrentuser])
    return (
        <Grid container>
                {
                    isEmpty(userName)?"":
                    <Grid item className={"m-1"}>
                        <h3 className={"my-0"} style={{color:"#fff"}}>
                            {userName}
                        </h3> 
                    </Grid>
                }
                         
            </Grid>
    );
}

export default injectIntl(DaShBoardHeader);
